// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"661":"1403f52a0a89b96285ae","838":"46cd7221364fea916965"}[chunkId] + ".js";
};